import React, { FC, useState } from 'react';
import HerdForm from './HerdForm';
import { DialogTitle } from './CustomDialogTitle';
import { Dialog, DialogContent, Button, MenuItem, ListItemIcon } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';

interface HerdFormModalProps {
  type?: 'button' | 'menu' | 'compact';
  handleCloseMenu?: () => void;
  // When provided, the dialog closes on success and the created herd is
  // handed back instead of navigating to its page.
  onSuccess?: (herd: { id: string; herdName: string }) => void;
}

const HerdFormModal: FC<HerdFormModalProps> = ({ type = 'button', handleCloseMenu = () => {}, onSuccess }) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpenMenu = () => {
    handleClickOpen();
    handleCloseMenu();
  };

  const handleSuccess = onSuccess
    ? (herd: { id: string; herdName: string }) => {
        setOpen(false);
        onSuccess(herd);
      }
    : undefined;

  return (
    <div>
      {type === 'menu' ? (
        <MenuItem onClick={handleOpenMenu}>
          <ListItemIcon>
            <AddCircleIcon style={{ marginRight: 'var(--space-icon-gap)' }} />
            Create Herd
          </ListItemIcon>
        </MenuItem>
      ) : type === 'compact' ? (
        <Button
          type="button"
          color="primary"
          variant="outlined"
          onClick={handleClickOpen}
          startIcon={<AddCircleIcon />}
          sx={{ whiteSpace: 'nowrap', ml: 1 }}
          aria-label="Create new herd"
        >
          New
        </Button>
      ) : (
        <Button
          color="primary"
          variant="contained"
          onClick={handleClickOpen}
          fullWidth
          sx={{ mt: 'var(--space-stack-normal)' }}
          size="large"
          startIcon={<AddCircleIcon />}
        >
          Create New Herd
        </Button>
      )}
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="sm"
        PaperProps={{ sx: { p: 0, overflow: 'hidden' } }}
        fullWidth
      >
        <DialogTitle onClose={handleClose}>Create a new herd</DialogTitle>
        <DialogContent>
          <HerdForm onSuccess={handleSuccess} />
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default HerdFormModal;
